<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('record.tbjl')}}</div>
        </div>
        <div class="mescroll">
          <ul class="item-box" @scroll="listenScroll">
              <li class="item" v-for="(item,index) in list" :key="index">
                <img class="img" src="@/assets/new/tibi2.png" alt="">
                <div class="item-right">
                    <div class="item-head">
                        <div class="item-lt">
                            <div class="t1">{{ item.currency }}</div>
                            <div class="time">{{ item.add_time | timeGs }}</div>
                        </div>
                        <div class="item-rt">
                            <div class="t2">{{ item.money }}</div>
                            <div class="status" :class="{under: item.status == 0}">{{item.status | status}}</div>
                        </div>
                    </div>
                    <div class="remark"  v-show="item.status == -1">{{ item.remark_re }}</div>
                </div>
            </li>
            <no-data v-show="isNoData"></no-data>
          </ul>
          <img id="goTop" class="go-top" @click="goTop" v-show="isGoTOP" src="@/assets/top.png" alt="">
        </div>
    </div>
</template>
<script>
import noData from '@/components/noData.vue'
import VueBetterScroll from 'vue2-better-scroll'
let that;
export default {
    name: 'tbjl',
    data () {
        return {
            tabIdx: 1,
            isNoData: false,
            list: [],
            statusText: [],
            isGoTOP: false,
            curDataLength: 10,
            theme: false,
            page: 1,
            scrollToTime: 500,
            limit: 20,
            timestamp: 0
        }
    },
    beforeCreate() {
        that = this;
    },
    created(){
        this.tabIdx = this.$route.query.idx || 1;
        this.statusText = this.$t('status.statusText');
    },
    mounted() {
        this.getMyLog()
    },
    methods: {
        goTop(){
           $('.item-box').animate({scrollTop:'0px'},'slow');
        },
        getMyLog(){
            let url = this.tabIdx ? '/web/takeLog' : '/web/rechargeLog';
            let params = {
                page: this.page
            }
            this.$ajax.get(url,{params}).then((res) => {
                let resData = res.data.data.data;
                if(resData.length > 0){
                    this.list = this.list.concat(resData);
                    this.curDataLength = resData.length;
                }else{
                    this.curDataLength = resData.length;
                }
                if(this.list.length > 0){
                    this.isNoData = false;
                }else{
                    this.isNoData = true;
                }
            }).catch(function(err){
                console.log(err)
            })
       },
       listenScroll(e) {  //监听滚动
            let ele = e.srcElement ? e.srcElement : e.target;
            if(ele.scrollTop > 200){
                this.isGoTOP = true
            }else{
                this.isGoTOP = false
            }
            if (ele.scrollTop + ele.offsetHeight >= ele.scrollHeight) { //监听滚动到div底部
                if(this.curDataLength > 0){
                    this.page ++;
                    this.getMyLog();
                }
            }
        },
        goBack(){
            this.$router.go(-1);
        },
        alert(cont){
            this.isMask = true;
            this.isShow = true;
            this.cont = cont;
        },
        close(){
            this.isShow = false;
            this.isMask = false;
            this.isDate = false;
        }
    },
    filters: {
        status: function(val){
            if(val == -1){
                return that.statusText[0]
            }else if(val == 0){
                return that.statusText[1]
            }else if(val == 1){
                return that.statusText[2]
            }else{
                return that.statusText[0]
            }
        },
    },
    components:{
        noData,
        VueBetterScroll
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .32rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        left: 0;
        top: 0;
        z-index: 999;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        /* background: #0e1530; */
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .head .icon2{
        position: absolute;
        top: 50%;
        right: .14rem;
        width: .42rem;
        height: .48rem;
        transform: translate(-50%,-50%);
    }
    .mescroll .item-box{
        position: absolute;
        top: 1.3rem;
        bottom: 0;
        width: 100%;
        overflow-y: scroll;
    }
    .mescroll .item-box .item{
        display: flex;
        align-items: stretch;
        padding: .6rem .5rem 0 .56rem;
    }
    .mescroll .item-box .item .img{
        width: .68rem;
        height: .68rem;
        margin-right: .3rem;
    }
    .mescroll .item-box .item .item-right{
        flex: 1;
        padding-bottom: .4rem;
        border-bottom: 1px solid #313a47;
    }
    .mescroll .item-box .item .item-head{
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .mescroll .item-box .item .t1{
        color: #fff;
        font-size: .48rem;
    }
    .mescroll .item-box .item .t2{
        color: #fff;
        font-size: .52rem;
        text-align: right;
    }
    .mescroll .item-box .item .time{
        padding-top: .36rem;
        color: #797979;
        font-size: .4rem;
    }
    .mescroll .item-box .item .status{
        padding-top: .36rem;
        color: #575757;
        font-size: .4rem;
        text-align: right;
    }
    .mescroll .item-box .item .under{
        color: #588bf8;
    }
    .mescroll .item-box .item:last-child .item-right{
        border-bottom: none;
    }
    .mescroll .item-box .item .remark{
        color: #fff;
        font-size: .36rem;
        padding: .24rem 0 0;
    }
</style>



// WEBPACK FOOTER //
// src/pages/tbjl.vue